import tw from "twin.macro"
import styled from "@emotion/styled/macro"

import { Small } from "../../Styled/Text"

export const Breadcrumbs = styled.nav`
  ${tw`hidden mb-6 md:mb-15 text-navy`}
  ${({ screen }) =>
    screen === `md` ? `hidden md:flex flex-row items-center mb-15 text-navy` : tw`flex flex-wrap items-center justify-start md:hidden`}
`
export const Item = tw(Small)`block mr-2 font-normal last:mr-0 last:font-bold`
